"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE = exports.CONTENT_INTEREST_TIMEFRAMES_NEW = exports.CONTENT_INTEREST_TIMEFRAMES = exports.CAMPAIGN_TYPES = exports.ENGAGEMENT_LEVEL_VALUES = exports.PRODUCT_CATEGORY = exports.PRODUCT_SKU = exports.COUPON = exports.AMOUNT = exports.DELIVERY_METHOD = exports.PAYMENT_METHOD = exports.ATTRIBUTE = exports.SEGMENT = exports.UC_BROWSER = exports.CUSTOM = exports.MICROSOFT_EDGE = exports.SAFARI = exports.INTERNET_EXPLORER = exports.FIREFOX = exports.CHROME = exports.SAVED_URLS = exports.ELEMENT_SELECTOR = exports.CLASS_SELECTOR = exports.ID_SELECTOR = exports.IS_NOT_DECLARED = exports.IS_DECLARED = exports.IGNORE_PARAMETERS = exports.THUNDERSTORM = exports.SNOW = exports.SMOKE = exports.RAIN = exports.MIST = exports.FOG = exports.DUST = exports.DRIZZLE = exports.CLOUDS = exports.CLEAR = exports.IS_BETWEEN = exports.LOWER_THAN_OR_EQUALS = exports.GREATER_THAN_OR_EQUALS = exports.LOWER_THAN = exports.GREATER_THAN = exports.NOT_CONTAINS = exports.REGEXP = exports.CONTAINS = exports.ALL_VALUES = exports.NOT_EQUALS = exports.EQUALS = void 0;
// 0x => generic conditions group
exports.EQUALS = 1;
exports.NOT_EQUALS = 2;
exports.ALL_VALUES = 3;
// 1x => string conditions group
exports.CONTAINS = 10;
exports.REGEXP = 11;
exports.NOT_CONTAINS = 13;
// 2x => number conditions group
exports.GREATER_THAN = 20;
exports.LOWER_THAN = 21;
exports.GREATER_THAN_OR_EQUALS = 22;
exports.LOWER_THAN_OR_EQUALS = 23;
exports.IS_BETWEEN = 24;
// 3x => Weather conditions group
exports.CLEAR = 30;
exports.CLOUDS = 31;
exports.DRIZZLE = 32;
exports.DUST = 33;
exports.FOG = 34;
exports.MIST = 35;
exports.RAIN = 36;
exports.SMOKE = 37;
exports.SNOW = 38;
exports.THUNDERSTORM = 39;
// 4x => Other conditions group
exports.IGNORE_PARAMETERS = 40;
exports.IS_DECLARED = 41;
exports.IS_NOT_DECLARED = 42;
exports.ID_SELECTOR = 43;
exports.CLASS_SELECTOR = 44;
exports.ELEMENT_SELECTOR = 45; // 'Custom'
// Saved Urls
exports.SAVED_URLS = 50;
// list of navigators id
exports.CHROME = 1;
exports.FIREFOX = 2;
exports.INTERNET_EXPLORER = 3;
exports.SAFARI = 4;
exports.MICROSOFT_EDGE = 5;
exports.CUSTOM = 6;
exports.UC_BROWSER = 7;
// list of segment types
exports.SEGMENT = 1;
exports.ATTRIBUTE = 2;
// Last purchase properties
exports.PAYMENT_METHOD = 1;
exports.DELIVERY_METHOD = 2;
exports.AMOUNT = 3;
exports.COUPON = 4;
exports.PRODUCT_SKU = 5;
exports.PRODUCT_CATEGORY = 6;
// Engagement Level id
var ENGAGEMENT_LEVEL_VALUES;
(function (ENGAGEMENT_LEVEL_VALUES) {
    ENGAGEMENT_LEVEL_VALUES[ENGAGEMENT_LEVEL_VALUES["LOYAL"] = 1] = "LOYAL";
    ENGAGEMENT_LEVEL_VALUES[ENGAGEMENT_LEVEL_VALUES["VALUABLE"] = 2] = "VALUABLE";
    ENGAGEMENT_LEVEL_VALUES[ENGAGEMENT_LEVEL_VALUES["WANDERERS"] = 3] = "WANDERERS";
    ENGAGEMENT_LEVEL_VALUES[ENGAGEMENT_LEVEL_VALUES["DISENGAGED"] = 4] = "DISENGAGED";
})(ENGAGEMENT_LEVEL_VALUES = exports.ENGAGEMENT_LEVEL_VALUES || (exports.ENGAGEMENT_LEVEL_VALUES = {}));
// Campaign type (Campaign exposure purpose)
var CAMPAIGN_TYPES;
(function (CAMPAIGN_TYPES) {
    CAMPAIGN_TYPES[CAMPAIGN_TYPES["EXPERIMENTATION"] = 1] = "EXPERIMENTATION";
    CAMPAIGN_TYPES[CAMPAIGN_TYPES["PERSONALIZATION"] = 2] = "PERSONALIZATION";
})(CAMPAIGN_TYPES = exports.CAMPAIGN_TYPES || (exports.CAMPAIGN_TYPES = {}));
// Content Interest times
var CONTENT_INTEREST_TIMEFRAMES;
(function (CONTENT_INTEREST_TIMEFRAMES) {
    CONTENT_INTEREST_TIMEFRAMES[CONTENT_INTEREST_TIMEFRAMES["LAST_WEEK"] = 1] = "LAST_WEEK";
    CONTENT_INTEREST_TIMEFRAMES[CONTENT_INTEREST_TIMEFRAMES["LAST_TWO_WEEKS"] = 2] = "LAST_TWO_WEEKS";
})(CONTENT_INTEREST_TIMEFRAMES = exports.CONTENT_INTEREST_TIMEFRAMES || (exports.CONTENT_INTEREST_TIMEFRAMES = {}));
var CONTENT_INTEREST_TIMEFRAMES_NEW;
(function (CONTENT_INTEREST_TIMEFRAMES_NEW) {
    CONTENT_INTEREST_TIMEFRAMES_NEW[CONTENT_INTEREST_TIMEFRAMES_NEW["LAST_WEEK"] = 7] = "LAST_WEEK";
    CONTENT_INTEREST_TIMEFRAMES_NEW[CONTENT_INTEREST_TIMEFRAMES_NEW["LAST_TWO_WEEKS"] = 14] = "LAST_TWO_WEEKS";
})(CONTENT_INTEREST_TIMEFRAMES_NEW = exports.CONTENT_INTEREST_TIMEFRAMES_NEW || (exports.CONTENT_INTEREST_TIMEFRAMES_NEW = {}));
var DEVICE;
(function (DEVICE) {
    DEVICE[DEVICE["MOBILE"] = 1] = "MOBILE";
    DEVICE[DEVICE["TABLET"] = 2] = "TABLET";
    DEVICE[DEVICE["DESKTOP"] = 3] = "DESKTOP";
})(DEVICE = exports.DEVICE || (exports.DEVICE = {}));
//# sourceMappingURL=conditions.js.map